import { useState } from 'react';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';

interface PopoverWithCloseButtonProps {
  id: string;
  data: {
    title: string;
    body: string;
  };
  icon?: string;
  iconSize?: string;
  iconColor?: string;
}

const PopoverWithCloseButton = ({
  id,
  data,
  icon = 'bx bx-info-circle',
  iconSize = '1.5rem',
  iconColor = '#a3a6b7',
}: PopoverWithCloseButtonProps) => {
  const [popoverOpen, setPopoverOpen] = useState(false);

  const togglePopover = () => setPopoverOpen(!popoverOpen);

  return (
    <>
      <i
        id={id}
        className={icon}
        style={{
          cursor: 'pointer',
          fontSize: iconSize,
          color: iconColor,
        }}
        onClick={togglePopover}
      ></i>

      <Popover
        placement="right"
        isOpen={popoverOpen}
        target={id}
        toggle={togglePopover}
      >
        <PopoverHeader
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <span dangerouslySetInnerHTML={{ __html: data.title }}></span>
          <i
            className="ri-close-line"
            style={{
              cursor: 'pointer',
              float: 'right',
              fontSize: '1.2rem',
            }}
            onClick={togglePopover}
          ></i>
        </PopoverHeader>

        <PopoverBody dangerouslySetInnerHTML={{ __html: data.body }} />
      </Popover>
    </>
  );
};

export default PopoverWithCloseButton;
